import React from 'react'
import values from 'mout/object/values'
import { Col, Row } from 'reactstrap'
import sortByPropText from '../../../helpers/content/manageSets/sortByPropText'
import AssessDashCircle from '../AssessDashCircle';

// scaleDisplay =scoring.bySubtest[subtest.setId] && (scoring.bySubtest[subtest.setId].raw === 0 ? 0 : subtest.rawToScaleScoring[scoring.bySubtest[subtest.setId].raw])


export default function SubCirclesRow({
  subtests,
  scoring,
  scoringCompare,
  isStudent,
  selectedStudent,
  selectedGroupUA,
  userAssessment,
  userAssessmentId,
  user,
  groupUAs,
  assessmentId,
  isCompare,
  currentAssessmentId,
  test1,
  test2,
  isSwap,
  year
}) {
  let comparisionCheck = isCompare
  const colorsBySubtestType = {
    English: "purple",
    Math: "#f86c6b",
    Reading: "#20a8d8",
    Science: "#88dc54"
  };
  const fallbackColor = "#ffc107";
  const themeColors = {

    English: "english",
    Math: "danger",
    Reading: "primary",
    Science: "success"
  };
  const { role } = user;
  let gUA, assessmentSubtests;

  const studentMode = !!( userAssessment &&
    userAssessment.assessmentSubtests &&
    (role === 'Student' || selectedStudent)
  )
  const educatorMode = !!(role !== 'Student' && selectedGroupUA && groupUAs)

  let sortedSubtests = []
  if (studentMode) {
    sortedSubtests = sortByPropText(values(userAssessment.assessmentSubtests), 'index')
    scoring = scoring
    scoringCompare = scoringCompare
  } else if (educatorMode) {
    if (groupUAs[selectedGroupUA]) {
      gUA = groupUAs[selectedGroupUA][year][assessmentId]
      assessmentSubtests = gUA.assessmentSubtests
      scoring = scoring
      scoringCompare = scoringCompare
      sortedSubtests = sortByPropText(values(assessmentSubtests), 'index')
    }
  }

  const fallbackThemeColor = "warning";
  if (subtests) {
    let subCircles = [];
    const subs = sortByPropText(values(subtests), "index");
    sortedSubtests.forEach(subtest => {
      const labels = [subtest.displayName, "Missed"];
      let data = [1, 1];
      let datacompare = [1, 1];
      let backgroundColorSub = ["#4d4d4d", "#4d4d4d"];
      let hoverBackgroundColorSub = backgroundColorSub;
      let score, scaleDisplay ,compareScaleDisplay


      let scaleScore;

      if (subtest && scoring) {
        if (userAssessmentId) {
          scaleDisplay = scoring.bySubtest[subtest.setId] && scoring.bySubtest[subtest.setId].scale || 0
          if(selectedStudent===""  && typeof scaleScore!=="undefined" &&  isStudent===false ) {
            if(typeof scaleDisplay==="string" )
            {
              scaleDisplay = Number(scaleDisplay);
            }
            scaleDisplay = scaleDisplay.toFixed(1);
          } else if (scaleDisplay && selectedStudent === '' && isStudent === false) {
            scaleDisplay = Number(scaleDisplay).toFixed(1)
          }
          data = [scaleScore, 36 - scaleScore]
        } else if (selectedGroupUA) {
          scaleDisplay = Math.round(parseFloat(scoring.bySubtest[subtest.setId] && scoring.bySubtest[subtest.setId].scale) * 10) / 10
          if(selectedStudent==="" && typeof scaleDisplay !== 'undefined'){
            scaleDisplay = (Math.round(parseFloat(scoring.bySubtest[subtest.setId] && scoring.bySubtest[subtest.setId].scale) * 10) / 10).toFixed(1);
          }
          data = [scaleScore, 36 - scaleScore]
        }
      }

      let comparescaleScore
      if (subtest && scoringCompare) {
        if (userAssessmentId) {
          scoringCompare.bySubtest ?   
          (compareScaleDisplay = scoringCompare.bySubtest[subtest.setId] && scoringCompare.bySubtest[subtest.setId].scale || 0):0
          if(selectedStudent===""  && typeof scaleScore!=="undefined" &&  isStudent===false ) {
            if(typeof compareScaleDisplay==="string" )
            {
              compareScaleDisplay = Number(compareScaleDisplay);
            }
            compareScaleDisplay = compareScaleDisplay.toFixed(1);
          } else if (compareScaleDisplay && selectedStudent === '' && isStudent === false) {
            compareScaleDisplay = Number(compareScaleDisplay).toFixed(1)
          }
          datacompare = [scaleScore, 36 - scaleScore]
        } else if (selectedGroupUA) {
          compareScaleDisplay = Math.round(parseFloat(scoringCompare.bySubtest[subtest.setId] && scoringCompare.bySubtest[subtest.setId].scale) * 10) / 10
          if(selectedStudent==="" && typeof compareScaleDisplay !== 'undefined'){
            compareScaleDisplay = (Math.round(parseFloat(scoringCompare.bySubtest[subtest.setId] && scoringCompare.bySubtest[subtest.setId].scale) * 10) / 10).toFixed(1);
          }
          datacompare = [scaleScore, 36 - scaleScore]
        }
      }


      {/* 4 Section Donuts in Top Card */ }
      subCircles.push({
        labels,
        data,
        backgroundColor: backgroundColorSub,
        subject: subtest.displayName,
        score: scaleDisplay && !isNaN(scaleDisplay) ? scaleDisplay : 0,
        compareScore : compareScaleDisplay && !isNaN(compareScaleDisplay) ? compareScaleDisplay : 0 , 
        top: true,
        subtest,
        isCompare,
        test1:test1,
        test2:test2,
        isSwap: isSwap
      });

    });
    return (
      <Row>
        {subCircles &&
          subCircles.map(info => {
            return (
              <Col
                xs="6"
                md="3"
                lg="6"
                xl="3"
                key={`circle${info.subtest.setId}`}
              >
                <AssessDashCircle {...info } isCompare = {isCompare} />
              </Col>
            );
          })}
      </Row>
    );
  } else return null;
}



// WEBPACK FOOTER //
// ./src/components/Assessment/AssessDash/SubCirclesRow.js